import { Box, Container, Typography, Link, Grid, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const PRIMARY = "#CC0000";

const navLinks = [
  { label: "Top", path: "/" },
  { label: "Company", path: "/company" },
  { label: "Service", path: "/service" },
  { label: "News", path: "/news" },
  { label: "プライバシーポリシー", path: "/privacy" },
];

const FooterSection = () => (
  <Box component="footer" sx={{ bgcolor: "#1a1a1a", color: "white", pt: 8, pb: 4 }}>
    <Container maxWidth="lg">
      <Grid container spacing={6} sx={{ mb: 6 }}>
        {/* ブランド */}
        <Grid item xs={12} md={5}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
            <Box
              component="img"
              src="/logo.svg"
              alt="TriArrows"
              sx={{ height: 40, width: "auto", filter: "brightness(0) invert(1)" }}
            />
            <Typography sx={{ fontWeight: 900, fontSize: "1.2rem", color: "white" }}>
              TriArrows
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: "0.85rem",
              color: "rgba(255,255,255,0.6)",
              lineHeight: 1.9,
              maxWidth: 320,
            }}
          >
            ITの力で社会の課題を解決し、未来を創造する。
            <br />
            「システムの安定」と「顧客の心」を動かすハイブリッド・ソリューション。
          </Typography>
        </Grid>

        {/* ナビゲーション */}
        <Grid item xs={12} md={3}>
          <Typography
            sx={{
              fontSize: "0.75rem",
              fontWeight: 700,
              letterSpacing: 3,
              color: PRIMARY,
              mb: 2.5,
            }}
          >
            Navigation
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            {navLinks.map((link) => (
              <Link
                key={link.label}
                component={RouterLink}
                to={link.path}
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  "&:hover": { color: "white" },
                  transition: "color 0.2s",
                }}
              >
                {link.label}
              </Link>
            ))}
          </Box>
        </Grid>

        {/* 会社情報 */}
        <Grid item xs={12} md={4}>
          <Typography
            sx={{
              fontSize: "0.75rem",
              fontWeight: 700,
              letterSpacing: 3,
              color: PRIMARY,
              mb: 2.5,
            }}
          >
            Company Info
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Typography sx={{ fontSize: "0.9rem", color: "rgba(255,255,255,0.7)" }}>
              TriArrows合同会社
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.5)" }}>
              〒150-0011
              <br />
              石川県金沢市田上本町4-40
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.5)", mt: 0.5 }}>
              TEL: 090-7818-6067
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "rgba(255,255,255,0.5)" }}>
              設立: 2024年4月
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ bgcolor: "#333", mb: 3 }} />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 2,
        }}
      >
        <Typography sx={{ fontSize: "0.8rem", color: "rgba(255,255,255,0.4)" }}>
          © {new Date().getFullYear()} TriArrows合同会社. All rights reserved.
        </Typography>
        <Box
          sx={{
            width: 32,
            height: 3,
            bgcolor: PRIMARY,
          }}
        />
      </Box>
    </Container>
  </Box>
);

export default FooterSection;
